{
  "nav": {
    "tools": "Ferramentas",
    "openMenu": "Abrir menu",
    "subscription": "Assinatura",
    "configuration": "Configuração",
    "account": "Conta",
    "administration": "Administração",
    "ourTools": "Nossas ferramentas",
    "pricing": "Preços",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Ferramenta de flipping",
    "dropshipTool": "Ferramenta de dropship",
    "housingTool": "Ferramenta de housing",
    "inventoryAnalysisTool": "Ferramenta de análise de inventário",
    "snipeAlerts": "Alertas de snipe",
    "realmStats": "Estatísticas do reino",
    "tsmListGenerator": "Gerador de listas TSM",
    "tsmProfileSetupGuide": "Guia de configuração de perfil TSM",
    "dashboard": "Painel",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Configuração de região e reino",
    "personal": "Configuração pessoal",
    "discord": "Configuração do Discord"
  },
  "accountItems": {
    "settings": "Configurações"
  },
  "adminItems": {
    "stats": "Estatísticas",
    "userInfo": "Informações do usuário",
    "goldSubscription": "Assinatura ouro",
    "itemLookup": "Busca de item",
    "snipeAudit": "Auditoria de snipe",
    "emailPreviews": "Prévia de e-mails"
  },
  "buttons": {
    "login": "Entrar",
    "logout": "Sair",
    "register": "Registrar",
    "registerNow": "Registrar agora",
    "signIn": "Entrar",
    "tryAgain": "Tentar novamente",
    "goBack": "Voltar",
    "cancel": "Cancelar",
    "deactivate": "Desativar",
    "upgrade": "Atualizar",
    "upgradeToPremium": "Atualizar para Premium",
    "upgradeNow": "Atualizar agora",
    "unlockPremiumFeatures": "Desbloquear recursos Premium",
    "getMoreResultsAndFilters": "Obter mais resultados e filtros",
    "goToConfig": "Ir para configuração",
    "save": "Save",
    "close": "Fechar",
    "actions": "Ações",
    "copyToClipboard": "Copiar para a área de transferência",
    "saving": "Salvando…"
  },
  "loading": {
    "pleaseWait": "Por favor aguarde",
    "important": "Importante",
    "defaultWarning": "Por favor, não recarregue a página durante este processo.",
    "progressComplete": "{{percent}}% concluído",
    "loadingAriaLabel": "Carregando",
    "loadingProgressAriaLabel": "Progresso de carregamento: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Algo deu errado",
    "defaultMessage": "Ocorreu um erro! Aguarde alguns segundos e recarregue a página",
    "fetchDataFailed": "Falha ao carregar os dados do leilão"
  },
  "cancelDialog": {
    "title": "Cancelar assinatura",
    "confirmQuestion": "Tem certeza de que deseja cancelar sua assinatura?",
    "loseAccessNotice": "Você perderá o acesso às ferramentas e não será cobrado por pagamentos futuros.",
    "warning": "Atenção: ao cancelar sua assinatura, você perderá o acesso às ferramentas após o fim do seu acesso pago e não reembolsaremos assinaturas canceladas."
  },
  "dialog": {
    "confirm": "Confirmar",
    "cancel": "Cancelar"
  },
  "realmLimitPopup": {
    "title": "Limite de reinos excedido",
    "description": "Você selecionou mais reinos de venda do que a assinatura básica permite. Altere sua configuração ou atualize para premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Atualizar para Premium",
    "upgradeSubtitle": "Desbloqueie todo o poder do Flipping Pal",
    "enhancedFeatures": "Recursos aprimorados",
    "exclusiveFeatures": "Recursos Premium exclusivos",
    "alsoIncluded": "Também incluído"
  },
  "footer": {
    "changelog": "Registro de alterações"
  },
  "logoAlt": "Flipping Pal - seu site de flipping WoW favorito",
  "toggleNavAriaLabel": "Alternar menu de navegação",
  "mainNavAriaLabel": "Navegação principal",
  "toolNavAriaLabel": "Navegação de ferramentas",
  "simpleNavAriaLabel": "Navegação simples",
  "footerNavAriaLabel": "Navegação do rodapé",
  "clipboard": {
    "copied": "Copiado para a área de transferência!",
    "tsmCopied": "String TSM copiada para a área de transferência!",
    "exportCopied": "Código de exportação copiado com sucesso para a área de transferência.",
    "auctionatorCopied": "Listas de compras do Auctionator copiadas para a área de transferência!",
    "titleCopied": "{{title}} copiado para a área de transferência!",
    "copyFailed": "Falha ao copiar para a área de transferência"
  },
  "favorites": {
    "added": "Adicionado aos favoritos",
    "removed": "Removido dos favoritos"
  },
  "enabled": "ativado",
  "disabled": "desativado",
  "dataRefreshed": "Dados atualizados! {{count}} oportunidades encontradas.",
  "notFound": {
    "title": "Página não encontrada"
  },
  "paymentSuccess": {
    "title": "Pagamento bem-sucedido"
  },
  "pagination": {
    "summary": "Total de itens encontrados: {{total}} | Resultados por página: {{perPage}}",
    "summaryWithPages": "Total de itens encontrados: {{total}} | Resultados por página: {{perPage}} | Total de páginas: {{pages}}",
    "label": "Paginação",
    "firstPage": "Primeira página",
    "previousPage": "Página anterior",
    "nextPage": "Próxima página",
    "lastPage": "Última página",
    "pageAriaLabel": "Página {{page}}"
  },
  "stats": {
    "totalInvestment": "Investimento total",
    "estimatedSellPrice": "Preço de venda estimado",
    "profitAfterAHCut": "Lucro após a taxa da casa de leilões"
  },
  "filters": {
    "searchItems": "Pesquisar itens...",
    "watchVideoGuide": "Assistir guia em vídeo",
    "watchVideoIntro": "Assistir vídeo de introdução",
    "crossRealmVideoGuide": "Guia em vídeo da ferramenta de flipping entre reinos",
    "dropshipVideoGuide": "Guia em vídeo da ferramenta de flipping dropship",
    "housingVideoGuide": "Guia em vídeo da ferramenta de housing",
    "downloadXLSX": "Baixar dados como XLSX",
    "getAuctionatorLists": "Obter listas do Auctionator",
    "quality": "Qualidade",
    "selectQuality": "Selecionar qualidade",
    "qualities": "qualidades",
    "expansions": "Expansões",
    "selectExpansions": "Selecionar expansões",
    "expansionsMultiple": "expansões",
    "sellingRealms": "Reinos de venda",
    "selectSellingRealms": "Selecionar reinos de venda",
    "sellingRealmsMultiple": "reinos de venda",
    "buyingRealms": "Reinos de compra",
    "selectBuyingRealms": "Selecionar reinos de compra",
    "buyingRealmsMultiple": "reinos de compra",
    "categories": "Categorias",
    "selectCategories": "Selecionar categorias",
    "categoriesMultiple": "categorias",
    "sellRate": "Taxa de venda",
    "saleAvg": "Média de vendas",
    "haveCraftedItems": "Itens fabricados",
    "profitOnSaleAvg": "Lucro sobre a média de vendas",
    "saleAvgVsBuyPercent": "Média de vendas vs compra %",
    "profitSellVsBuy": "Lucro (venda vs compra)",
    "profitPercent": "Lucro %",
    "maxGoldBuyout": "Compra direta máx. em ouro",
    "ilvl": "ilvl",
    "activateProfitOnSaleAvg": "Ativar lucro sobre a média de vendas",
    "regionMarketValue": "Valor de mercado regional",
    "regionHistorical": "Valor histórico regional",
    "modeRecalculate": "Recalcular",
    "modeFilter": "Filtrar",
    "modeRecalculateHint": "Mudanças de filtro recalculam os resultados no servidor",
    "modeFilterHint": "Mudanças de filtro apenas refinam os resultados já carregados",
    "modeAria": "Comportamento ao mudar filtros",
    "modeLabel": "Ao mudar filtros"
  },
  "table": {
    "noData": "Nenhum dado encontrado",
    "sellVsBuyTooltip": "A taxa de 5% da casa de leilões é considerada no cálculo do lucro",
    "toggleAllFavorites": "Alternar todos os favoritos",
    "clickToCopy": "Clique para copiar: {{name}}",
    "priceAfterAHCut": "Preço após taxa do HL: {{price}}",
    "noCompetition": "Sem concorrência",
    "noCompetitionTooltip": "Nenhum anúncio conhecido no reino de venda.",
    "population": "População: {{population}}",
    "viewOnWowhead": "Ver {{name}} no Wowhead",
    "addToFavorites": "Adicionar aos favoritos",
    "removeFromFavorites": "Remover dos favoritos",
    "sessionExpiredFavorite": "Sessão expirada. Por favor, faça login novamente.",
    "failedToUpdateFavorite": "Falha ao atualizar favorito",
    "addSnipeAlert": "Adicionar alerta de snipe",
    "editSnipeAlert": "Editar alerta de snipe",
    "headers": {
      "itemName": "Nome do item",
      "category": "Categoria",
      "ilvl": "ilvl",
      "sellRate": "Taxa de venda",
      "expansion": "Expansão",
      "quality": "Qualidade",
      "extraStats": "Stats extras",
      "saleAvg": "Venda média",
      "regionMarketValue": "VM região",
      "saleAvgVsBuy": "Venda média vs Compra",
      "sellVsBuy": "Venda vs Compra",
      "sellPrice": "Preço de venda",
      "sellRealm": "Reino de venda",
      "buyPrice": "Preço de compra",
      "buyRealm": "Reino de compra"
    },
    "columnsTitle": "Colunas",
    "columnsReset": "Redefinir",
    "columnsDragToReorder": "Arraste para reordenar",
    "columnsToggleVisibility": "Clique no olho para alternar visibilidade",
    "columnSettings": "Configurações de colunas",
    "dragReorder": "Arraste para reordenar {{column}}",
    "hideColumn": "Ocultar {{column}}",
    "showColumn": "Mostrar {{column}}",
    "rowActions": "Ações da linha",
    "actions": {
      "selectionSection": "Seleção",
      "pinSection": "Fixar no topo",
      "selectPage": "Selecionar página",
      "deselectPage": "Desselecionar página",
      "selectAll": "Selecionar tudo",
      "deselectAll": "Desselecionar tudo",
      "sortFavorites": "Fixar favoritos",
      "sortSnipes": "Fixar alertas de snipe",
      "sortSelected": "Fixar selecionados",
      "columnSettings": "Configurações de colunas..."
    },
    "sortHint": "Clique para ordenar",
    "sortHintMulti": "Clique para ordenar · Shift+clique para ordenação secundária",
    "selectRow": "Selecionar {{name}}",
    "emptyFiltered": "Nenhum item corresponde aos seus filtros atuais",
    "emptyResetFilters": "Redefinir filtros",
    "emptyUpdating": "Uma atualização de região está em andamento — novos dados chegarão em breve."
  },
  "multipleSelect": {
    "noResults": "Nenhum resultado encontrado",
    "selectAll": "Selecionar tudo",
    "clearAll": "Limpar tudo",
    "selectOption": "Selecionar opção",
    "selectMultipleOptions": "Selecionar várias opções",
    "selected": "selecionado(s)",
    "searchOptions": "Pesquisar opções",
    "noItemsSelected": "Nenhum item selecionado",
    "search": "Buscar...",
    "items": "itens"
  },
  "hierarchicalSelect": {
    "selectAll": "Selecionar tudo",
    "clearAll": "Limpar tudo",
    "expand": "Expandir",
    "collapse": "Recolher",
    "selected": "selecionado(s)",
    "noItemsSelected": "Selecionar categorias...",
    "items": "categorias",
    "triggerAriaLabel": "Selecionar {{items}}. {{count}} selecionados."
  },
  "hoverChart": {
    "high": "Alto:",
    "low": "Baixo:",
    "avg": "Méd.:"
  },
  "tokenDisplay": {
    "label": "Ficha de WoW",
    "signalBuy": "Sinal de compra — o preço está favorável agora",
    "signalWait": "Aguarde — o preço provavelmente continuará caindo",
    "signalHold": "Mantenha — sem tendência clara no momento",
    "loading": "Carregando...",
    "error": "Erro",
    "priceHistory": "Histórico de preços de 14 dias",
    "high": "Alto: ",
    "low": "Baixo: ",
    "avg": "Méd.: ",
    "momentum": "Momentum",
    "slowing": "Desacelerando ({{steps}})",
    "atCap": "No limite de 1%",
    "steps": "{{count}} passo",
    "stepsPlural": "{{count}} passos"
  },
  "nextUpdate": {
    "nextDataUpdate": "Próxima atualização de dados",
    "dataSourceStatus": "Status das fontes de dados",
    "tsmData": "Dados TSM:",
    "blizzardRealm": "Reino Blizzard:",
    "liveUpdates": "Atualizações ao vivo:",
    "connected": "Conectado",
    "reconnecting": "Reconectando...",
    "retry": "Tentar novamente",
    "autoRefresh": "Atualização automática:",
    "autoRefreshEnabled": "A página será atualizada automaticamente quando novos dados estiverem disponíveis",
    "autoRefreshDisabled": "Clique no ícone de atualização quando novos dados estiverem prontos",
    "loadingStatus": "Carregando status dos dados...",
    "viewStatus": "Ver status das fontes de dados",
    "refreshData": "Atualizar dados",
    "reloading": "Recarregando",
    "liveUpdatesConnected": "Atualizações ao vivo conectadas",
    "liveUpdatesReconnecting": "Reconectando...",
    "tsmFresh": "Dados TSM atualizados (< 24h)",
    "tsmStale24": "Dados TSM ficando desatualizados (24-25h)",
    "tsmStale25": "Dados TSM desatualizados (> 25h)",
    "toggleAutoRefresh": "Alternar atualização automática"
  },
  "regionUpdateProgress": {
    "updating": "Atualizando dados da região",
    "realmsProgress": "{{updated}}/{{total}} reinos ({{percent}}%)",
    "autoRefresh": "Os dados serão atualizados automaticamente quando estiverem prontos",
    "reloadPartial": "Dados parciais disponíveis — carregar agora"
  },
  "filterFlyout": {
    "filtersButton": "Filtros",
    "loadingPresets": "Carregando...",
    "selectPreset": "Selecionar predefinição...",
    "presetsSection": "Predefinições",
    "save": "Salvar",
    "update": "Atualizar",
    "delete": "Excluir",
    "export": "Exportar",
    "import": "Importar",
    "importPreset": "Importar predefinição…",
    "presetNamePlaceholder": "Nome da predefinição...",
    "shareCode": "Compartilhar este código:",
    "copy": "Copiar",
    "done": "Concluído",
    "pasteCodePlaceholder": "Colar código aqui...",
    "applyFilters": "Aplicar filtros",
    "resetFilters": "Redefinir filtros",
    "refreshNow": "Atualizar agora",
    "reset": "Redefinir",
    "deletePresetTitle": "Excluir predefinição",
    "deletePresetMessage": "Tem certeza de que deseja excluir esta predefinição? Isso não pode ser desfeito."
  },
  "discord": {
    "title": "Integração com Discord",
    "description": "Vincule sua conta do Discord para receber notificações personalizadas e atualizações do nosso bot.",
    "accountLinked": "Conta do Discord vinculada",
    "connectedAs": "Conectado como:",
    "unlink": "Desvincular",
    "dmVerifiedBadge": "DMs verificados: Seu Discord pode receber notificações do nosso bot.",
    "dmVerificationTitle": "Verificação de DMs necessária",
    "dmVerificationDesc": "Para habilitar notificações, precisamos confirmar que nosso bot pode te enviar mensagens diretas. Certifique-se de ter os DMs habilitados para pelo menos um servidor que você compartilha com nosso bot.",
    "sendVerificationCode": "Enviar código de verificação para meu Discord",
    "sendingCode": "Enviando código...",
    "codeSentInstructions": "Verifique seus DMs do Discord para um código de 6 dígitos do nosso bot. Se não recebeu um DM, verifique em suas configurações em Conteúdo e Social > Permissões sociais se as mensagens diretas estão ativadas.",
    "enterCodePlaceholder": "Digite o código de 6 dígitos",
    "verify": "Verificar",
    "resendCode": "Reenviar código",
    "notificationSettings": "Configurações de notificação",
    "verifyDmsFirst": "(verifique os DMs primeiro)",
    "botFeaturesAvailable": "Recursos do bot disponíveis: Agora você pode receber mensagens privadas para atualizações de região, snipes de itens e pets, snipes iLvl BoE e preço do token do WoW.",
    "notConnected": "Não conectado: Vincule sua conta do Discord para habilitar notificações e recursos do bot.",
    "connectingToDiscord": "Conectando ao Discord...",
    "linkAccount": "Vincular conta do Discord",
    "regionUpdateLabel": "Notificações de atualização de região",
    "regionUpdateDesc": "Receba notificações quando os dados de leilões forem atualizados para suas regiões selecionadas.",
    "sendTestDm": "Enviar DM de teste",
    "sendingTest": "Enviando…",
    "sendTestWebhook": "Testar",
    "testMessageHint": "Envie uma mensagem de teste para confirmar que a entrega no Discord funciona sem esperar por um snipe real.",
    "categoriesTitle": "Categorias de notificação",
    "categoriesDesc": "Direcione alertas de snipe para diferentes canais do Discord. Cada categoria tem sua própria URL de webhook e modo de menção.",
    "categoriesPremiumHint": "Categorias adicionais exigem uma assinatura premium.",
    "categoryNamePlaceholder": "Nome da categoria",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Menção:",
    "defaultLabel": "Padrão",
    "defaultCategoryTitle": "Categoria padrão",
    "noWebhookSet": "nenhum webhook definido",
    "setAsDefault": "Definir como padrão",
    "edit": "Editar",
    "delete": "Excluir",
    "add": "Adicionar",
    "addCategory": "+ Adicionar categoria",
    "deleteCategoryTitle": "Excluir categoria",
    "deleteCategoryMessage": "Tem certeza de que deseja excluir a categoria \"{{name}}\"? Os alertas atribuídos a ela usarão sua categoria padrão."
  },
  "csvExport": {
    "title": "Exportar CSV",
    "noItems": "Nenhum item disponível.",
    "copy": "Copiar para a área de transferência",
    "copied": "CSV copiado para a área de transferência!",
    "copyFailed": "Falha ao copiar",
    "download": "Baixar CSV"
  },
  "updateBanner": {
    "title": "Atualização disponível",
    "description": "Uma nova versão está pronta.",
    "reload": "Recarregar",
    "dismiss": "Dispensar"
  },
  "premiumPreviewBanner": {
    "title": "Você tem acesso Premium completo",
    "dayLeftOne": "1 dia restante",
    "daysLeft": "{{count}} dias restantes",
    "dismiss": "Dispensar"
  },
  "tour": {
    "start": "Iniciar tour desta página"
  },
  "filterSidebar": {
    "profitRange": "Faixa de lucro",
    "crafted_include": "Todos os itens",
    "crafted_excluded": "Excluir fabricados",
    "crafted_exclusive": "Somente fabricados",
    "showPositiveSaleAvgVsBuy": "Somente média de venda positiva vs compra",
    "presetClickToDeselect": "Clique para desmarcar o preset",
    "collapseSidebar": "Recolher filtros",
    "expandSidebar": "Expandir filtros"
  },
  "dashboard": {
    "loadError": "Não foi possível carregar os dados do painel. Verifique sua conexão e tente novamente.",
    "greeting": {
      "morning": "Bom dia",
      "afternoon": "Boa tarde",
      "evening": "Boa noite"
    },
    "subtitle": "Aqui está o que está acontecendo na casa de leilões hoje.",
    "kpi": {
      "opportunities": "Oportunidades"
    },
    "topOpportunities": {
      "title": "Melhores oportunidades",
      "viewAll": "Ver tudo",
      "itemsFound": "itens encontrados em",
      "realms": "reinos",
      "openTool": "Abrir ferramenta de flipping",
      "ilvl": "ilvl",
      "sellRate": "taxa de venda",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Não foi possível salvar as configurações. O último valor salvo foi restaurado.",
      "saved": "Salvo",
      "sellRateTooltip": "A taxa de venda usa uma escala de 0 a 1: a proporção de leilões listados que realmente são vendidos por dia. 0,1 ≈ 10% dos anúncios."
    },
    "recentSnipes": {
      "title": "Snipes recentes",
      "monitoringRealms": "Monitorando {{count}} reinos",
      "vsTarget": "vs alvo",
      "itemsMonitored": "itens sendo monitorados",
      "configureAlerts": "Configurar alertas",
      "noSnipes": "Nenhum snipe detectado neste ciclo",
      "saved": "economizado"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Ver estatísticas de reinos"
    },
    "quickAccess": {
      "title": "Acesso rápido"
    },
    "onboarding": {
      "title": "Primeiros passos",
      "progress": "{{done}}/{{total}} concluídos",
      "hide": "Ocultar checklist",
      "steps": {
        "realms": "Configure seus reinos",
        "preset": "Crie um preset de filtros inicial",
        "flipping": "Faça sua primeira busca de flipping",
        "discordLink": "Vincule sua conta do Discord",
        "snipe": "Configure alertas de snipe",
        "discordJoin": "Entre no servidor do Discord"
      },
      "createPreset": "Criar preset",
      "creatingPreset": "Criando…",
      "starterPresetName": "Inicial",
      "configureRealmsFirst": "Configure seus reinos primeiro para criar um preset",
      "presetLimitReached": "Você atingiu o limite de presets salvos",
      "createPresetFailed": "Não foi possível criar o preset. Tente novamente."
    },
    "activity": {
      "title": "Atividade",
      "timeAgoLess1m": "<1m atrás",
      "timeAgoMinutes": "{{count}}m atrás",
      "timeAgoHours": "{{count}}h atrás",
      "dataRefreshed": "Dados atualizados — {{n}} oportunidades encontradas",
      "realmDataUpdated": "Dados dos reinos {{region}} atualizados",
      "waitingForData": "Aguardando primeira atualização de dados…",
      "snipeAlertsActive": "Alertas de snipe ativos monitorando seus reinos",
      "tokenTracked": "O preço do WoW Token é monitorado a cada 20 minutos"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Voltar ao topo",
  "slider": {
    "min": "Mín",
    "max": "Máx",
    "minAriaLabel": "Valor mínimo",
    "maxAriaLabel": "Valor máximo",
    "numericInput": "Entrada numérica de {{label}}"
  },
  "inputBox": {
    "clear": "Limpar entrada",
    "required": "obrigatório"
  },
  "auctionator": {
    "title": "Listas de compras do Auctionator",
    "account": "Conta:",
    "allAccounts": "Todas as contas",
    "noItems": "Nenhum item disponível para a conta selecionada."
  },
  "popup": {
    "getTitle": "Obter {{title}}",
    "content": "Conteúdo",
    "noContent": "Nenhum conteúdo disponível",
    "copyTitle": "Copiar {{title}}",
    "copyContent": "Copiar conteúdo",
    "titleContent": "Conteúdo de {{title}}",
    "videoContent": "Conteúdo de vídeo",
    "videoNotSupported": "Seu navegador não suporta a tag de vídeo."
  },
  "snipePopup": {
    "ariaLabel": "Alerta de snipe para {{name}}",
    "titleItem": "Alerta de snipe de item",
    "titlePet": "Alerta de snipe de mascote",
    "maxBuyoutPrice": "Preço máximo de compra imediata",
    "pricePlaceholder": "ex.: 500g ou 500g 50s",
    "saving": "Salvando...",
    "updateAlert": "Atualizar alerta",
    "setAlert": "Definir alerta"
  },
  "refreshingData": "Atualizando dados...",
  "toolAccess": {
    "subscriptionRequired": "Você precisa de uma assinatura ativa para usar esta ferramenta!",
    "premiumRequired": "Você precisa de uma assinatura premium ativa para usar esta ferramenta!"
  }
}
